import { getSurahTotalVerses } from './helpers';

// A position is carried in the fragment, as #surah:verse — for example #2:255.
// The fragment keeps this working on any static host: no rewrite rule is needed,
// and a shared link can never 404.

const PATTERN = /^#?(\d{1,3}):(\d{1,3})$/;

// Parse a fragment into a position, or null when it is absent or out of range.
export const parseDeepLink = (hash) => {
  const match = PATTERN.exec(hash || '');
  if (!match) return null;

  const surah = parseInt(match[1], 10);
  const verse = parseInt(match[2], 10);

  if (!(surah >= 1 && surah <= 114)) return null;
  // Verse 0 is the Bismillah, so it is a valid target.
  if (!(verse >= 0 && verse <= getSurahTotalVerses(surah))) return null;

  return { surah, verse };
};

export const formatDeepLink = (surah, verse) => `#${surah}:${verse}`;

export const deepLinkUrl = (surah, verse) => {
  const { origin, pathname } = window.location;
  return `${origin}${pathname}${formatDeepLink(surah, verse)}`;
};
